import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./address-options-section.scss";
import {RadioOption} from "../../../common/radio-option/radio-option";
import {ErrorHighlighter} from "../../../../../../../light/error-highlighter";
import {cx} from "emotion";
import {scopedState} from "../../../../../../../../react/scoped-state";
import {bindInput} from "../../../../../../../../react/bind-input";
import {UseState} from "../../../../../../../../react/use-state";
import {Select} from "../../../../../../common/design2/select/select";
import {Checkbox} from "../../../../../../common/design2/checkbox/checkbox";
import {InformationBadge} from "../../../../../../common/design2/information-badge/information-badge";

export const AddressOptionsSection = ({state, nameOverride, addAdditionalOptions, next}) => cs(
    ["eh", (_, next) => ErrorHighlighter({next})],

    ({eh}) => next({
        invalid: (state.value === "custom" && !nameOverride.value) || 
                (addAdditionalOptions.value && state.value === "owner"),
        highlightErrors: () => {
            eh.start();
        },
        render: ({showErrors}) => {
            const ownerOptions = ["or_resident","or_occupant","or_homeowner"];
            const Option = ({value, label, extra=undefined}) => {
                const selected = state.value === value || 
                (value === 'owner' && ownerOptions.indexOf(state.value) !==  -1);
                return RadioOption({
                    label,
                    selected,
                    extra: selected && extra?.(),

                    onSelect: () => {
                        addAdditionalOptions.onChange(false);
                        state.onChange(value);
                    },
                    xdQaName: "Demographics Search "+label,
                });
            };

            return (
                <div className="address-options-section-48d">
                    <div className="title" xd-qa-type="label" xd-qa-name="Demographics Search Addressing Options">
                        Addressing Options
                    </div>

                    <div className="content">
                        <div className="dual-panel">
                            <div className="left" xd-qa-type="label" xd-qa-name="Demographics Search Addressing Options Description">
                                Choose how you want the resident to appear for addresses you have selected.
                                {state?.value === 'custom' && (
                                    <div className="additional-info">
                                        <div className="heading-section"><img className="address-image" src='/next_images/Address-Warning.svg'/>{"Not recommended for"}</div>
                                        <div className="list-section">
                                            Capturing leads on your Lead Analytics Dashboard, as original recipient names will be replaced.
                                        </div>
                                    </div>
                                )}
                                {((state?.value === 'owner' && addAdditionalOptions.value) || ownerOptions.indexOf(state?.value) !==  -1) && (
                                    <div className="additional-info">
                                        <div className="heading-section"><img className="address-image" src='/next_images/Address-Success.svg'/>{"Good for"}</div>
                                        <ul className="list-section">
                                            <li>
                                                Improved deliverability rate and reduced returned mail
                                            </li>
                                            <li>
                                                Delivering to the address and not the person
                                            </li>
                                            <li>
                                                Apartments due to high residency turnover
                                            </li>
                                        </ul>
                                        <div className="heading-section"><img className="address-image" src='/next_images/Address-Warning.svg'/>{"Not recommended for"}</div>
                                        <ul className="list-section">
                                            <li>
                                                PO Box addresses
                                            </li>
                                            <li>
                                                Areas with high seasonal residency
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                            <div className={cx("right", eh.css)}>
                                {Option({
                                    value: "owner",
                                    label: "Use resident name",
                                })}
                                <div className="options">
                                    {(state?.value === 'owner' || ownerOptions.indexOf(state.value) !==  -1) && (
                                        <div
                                            className="apply-to-owner-section"
                                        >
                                            <div className="checkbox-div" 
                                                onClick={() => {
                                                    if(addAdditionalOptions.value) {
                                                        state.onChange('owner');
                                                    } else {
                                                        state.onChange('or_resident');
                                                    }
                                                    addAdditionalOptions.change(v => !v);
                                                }}>
                                                {Checkbox({
                                                    checked: addAdditionalOptions.value,
                                                })}
                                            </div>
                                            <div className="add-label">
                                                Add
                                            </div>
                                            {(state?.value === 'owner' || ownerOptions.indexOf(state.value) !==  -1) &&
                                                Select({
                                                        forcedExpandLeft: true,
                                                        disabled: !addAdditionalOptions.value,
                                                        list: [
                                                            {
                                                                value: "or_resident",
                                                                label: "OR RESIDENT",
                                                            },
                                                            {
                                                                value: "or_occupant",
                                                                label: "OR OCCUPANT",
                                                            },
                                                            {
                                                                value: "or_homeowner",
                                                                label: "OR HOMEOWNER",
                                                            },
                                                        ],
                                                        itemToLabel: (e) => e?.label,
                                                        onChange: (e) => state.onChange(e.value),
                                                        isSelected: (e) => state.value == e.value,
                                                        xdQaName: "Use resident additional options type"
                                                    })
                                                }
                                                <span style={{marginLeft: "5px", marginTop: "7px"}}>
                                                    {InformationBadge({
                                                        getTooltip: () => "Appears below resident name",
                                                        xdQaName: "Select options tooltip",
                                                    })}
                                    </span>
                                        </div>
                                    )}
                                </div>
                            
                                {Option({
                                    value: "custom",
                                    label: "Replace name",
                                    extra: () => (
                                        <input {...{
                                            autoFocus: true,
                                            placeholder: "Custom name...",
                                            maxLength: 50,
                                            className: cx(eh.css, {hasError: showErrors && !nameOverride.value}),
                                            ...bindInput(nameOverride),
                                            "xd-qa-type": "text_field",
                                            "xd-qa-name": "Demographic Replace name",
                                        }}/>
                                    ),
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            );
        },
    }),
);
